import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../../pages/home/home';
import About from '../../pages/about/about';
import MainLayout from '../../layout/main-layout';
import Service from '../../pages/service/services';
import Contact from '../../pages/contact/contact';
import Digitalbranding from '../../pages/digitalbranding/digitalbranding'
import Awarenesssoutions from '../../pages/awarenesssolutions/awarenesssolutions'
import Revenuegrowth from '../../pages/revenuegrowth/revenuegrowth'
import Socialmedia from '../../pages/socialmedia/socialmedia'
import Seo from '../../pages/seo/seo'
import Performancemarketing from '../../pages/performancemarketing/performancemarketing'


const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Home />} />
        <Route path="/digitalbranding" element={<Digitalbranding />} />
        <Route path="/awarenesssoutions" element={<Awarenesssoutions />} />
        <Route path="/revenuegrowth" element={<Revenuegrowth />} />
        <Route path="/socialmedia" element={<Socialmedia />} />
        <Route path="/seo" element={<Seo />} />
        <Route path="/performancemarketing" element={<Performancemarketing />} />
        <Route path="/about" element={<About />} />
        <Route path="/service" element={<Service />} />
        <Route path="/contact" element={<Contact />} />

      </Route>

    </Routes>


  );
};

export default AppRoutes;
